import React, { useState } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import { StudentSearchPicker } from "./StudentSearchPicker";

function AddStudentModal({ show, onHide, onAdd, isLoading, error }) {
  const [name, setName] = useState("");
  const [selected, setSelected] = useState(null);
  const [mode, setMode] = useState("existing"); // 'existing' | 'new'

  const reset = () => {
    setName("");
    setSelected(null);
    setMode("existing");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mode === "existing") {
      if (!selected) return;
      onAdd({ student_id: selected.id });
    } else {
      onAdd({ quick_create: { name } });
    }
  };

  const handleHide = () => {
    reset();
    onHide();
  };

  const canSubmit = mode === "existing" ? Boolean(selected) : name.trim().length > 0;

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Agregar estudiante a la clase</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" className="mb-3">
              {error.message ?? "Error al agregar estudiante."}
            </Alert>
          )}
          <div className="d-flex gap-3 mb-3">
            <Form.Check
              type="radio"
              id="mode-existing"
              label="Estudiante registrado"
              checked={mode === "existing"}
              onChange={() => setMode("existing")}
            />
            <Form.Check
              type="radio"
              id="mode-new"
              label="Alta rápida"
              checked={mode === "new"}
              onChange={() => setMode("new")}
            />
          </div>

          {mode === "existing" ? (
            <StudentSearchPicker selected={selected} onSelect={setSelected} />
          ) : (
            <>
              <Form.Group controlId="student-name">
                <Form.Label>Nombre completo</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nombre del estudiante"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  style={{ minHeight: 44 }}
                />
              </Form.Group>
              <Alert variant="light" className="border small text-muted mt-2 mb-0">
                El alta rápida crea un registro provisional (sin saldo ni cuenta).
                Podrás vincularlo luego a un estudiante formal desde su ficha.
              </Alert>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleHide} style={{ minHeight: 44 }}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={isLoading || !canSubmit}
            style={{ minHeight: 44 }}
          >
            {isLoading ? <Spinner size="sm" /> : "Agregar"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export { AddStudentModal };
